<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    hide-header-close
    centered
    no-close-on-esc
    no-close-on-backdrop
    @shown="onShown"
    @hidden="resetForm"
  >
    <div class="p-2">
      <img
        src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
        alt="Lanjutkan ke CPAS"
        class="mx-auto mb-2 w-24 h-24"
      >
      <div class="mb-2 text-center">
        <h2 class="font-bold text-black text-2xl mb-1">
          Lanjutkan ke CPAS
        </h2>
        <p class="text-secondary">
          Silahkan isi nama akun WL yang akan disetujui untuk lanjut ke tahap CPAS
        </p>
      </div>
      <validation-observer
        ref="continueCPASForm"
        #default="{invalid}"
      >
        <b-form
          class="grid grid-cols-1"
          @submit.prevent="continueToCPAS"
        >
          <validation-provider
            #default="{ errors }"
            name="Nama Akun"
            rules="required"
          >
            <div class="mb-[16px] text-left">
              <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                Nama Akun WL sesuai format
                <span class="text-primary">*</span>
              </label>
              <b-form-input
                v-model="form.account_name"
                :state="errors.length > 0 ? false : null"
                placeholder="Masukkan nama disini"
              />
              <small
                v-if="errors.length > 0 || validationError.account_name"
                class="text-danger d-block"
              >{{ errors[0] || validationError.account_name }}</small>
            </div>
          </validation-provider>

          <ValidationProvider
            v-slot="{ errors }"
            name="Business Manager"
            rules="required"
          >
            <div class="mb-[16px] text-left">
              <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                Pilih Business Manager
                <span class="text-primary">*</span>
              </label>
              <BFormSelect
                v-model="form.system_bm_id"
                :options="metaBusinessManagerOptions"
              />
              <span
                v-if="errors.length > 0 || validationError.system_bm_id"
                class="text-danger text-sm"
              >{{ errors[0] || validationError.system_bm_id }}</span>
            </div>
          </ValidationProvider>

          <validation-provider
            #default="{ errors }"
            name="ID Ad Account"
            rules="required|numeric"
          >
            <div class="mb-[16px] text-left">
              <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                ID Ad Account
                <span class="text-primary">*</span>
              </label>
              <b-form-input
                v-model="form.ad_account_id"
                :state="errors.length > 0 ? false : null"
                placeholder="Masukkan ID Ad Account"
              />
              <small
                v-if="errors.length > 0 || validationError.ad_account_id"
                class="text-danger d-block"
              >{{ errors[0] || validationError.ad_account_id }}</small>
            </div>
          </validation-provider>

          <div class="flex gap-[1rem] mt-2">
            <b-button
              variant="outline-primary"
              block
              @click="handleClose"
            >
              Batal
            </b-button>
            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="invalid"
              class="!m-0"
            >
              Lanjutkan ke CPAS
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormSelect,
} from 'bootstrap-vue'
import { required, numeric } from '@validations'
import { newAxiosIns } from '@/libs/axios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BForm,
    BButton,
    BFormInput,
    BFormSelect,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    validationError: {
      type: Object,
      default: () => ({
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      }),
    },
  },
  data() {
    return {
      required,
      numeric,
      form: {
        status: 'on process cpas',
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      },
      metaBusinessManagerOptions: [],
    }
  },
  methods: {
    /**
     * Handler executed when the component or modal is shown.
     *
     * - Only runs when the selected platform is `meta`
     *
     * @returns {void}
     */
    onShown() {
      this.loadSystemBusinessManagerList()
    },
    /**
     * Fetches the system Meta Business Manager list from the API.
     *
     * - Calls the system BM endpoint
     * - Maps API response into `metaBusinessManagerOptions`
     *   for select/dropdown usage
     * - Shows an error toast if the request fails
     *
     * @async
     * @returns {Promise<void>}
     */
    async loadSystemBusinessManagerList() {
      try {
        const {
          data: { data },
        } = await newAxiosIns.get('komads/api/v1/admin/system_bm/list')

        this.metaBusinessManagerOptions = [
          { value: '', text: 'Pilih Business Manager' },
          ...data.map(system => ({
            value: `${system.id}`,
            text: `${system.bm_name} - ${system.bm_id}`,
          })),
        ]
      } catch {
        this.$toast_error({
          message: 'Failed to load business manager list',
        })
      }
    },
    /**
     * Emits an event to the parent component to confirm the approval.
     */
    continueToCPAS() {
      this.$emit('continue-to-cpas', this.form)
      this.$bvModal.hide(this.id)
    },
    handleClose() {
      this.$bvModal.hide(this.id)
      this.resetForm()
    },
    resetForm() {
      this.form.account_name = ''
      this.form.system_bm_id = ''
      this.form.ad_account_id = ''
    },
  },
}
</script>

<style scoped>
.text-black {
  color: #333333;
}
</style>
